import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { StorageService } from '@services/storage.service';

/**
 * Stores the treatment type query param so it is available before any other page logic runs.
 */
@Injectable({
  providedIn: 'root',
})
export class StoreTreatmentTypeQueryParamGuard implements CanActivate {
  private storageService = inject(StorageService);

  /**
   * Stores the treatment type query param if present and valid, and always activates the route.
   *
   * @param {ActivatedRouteSnapshot} route the route snapshot to check for the treatment type query param
   *
   * @returns {boolean} true to always activate the route
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const treatmentType = route.queryParams.treatmentType;

    if (Object.values(ConsultationTreatmentTypes).includes(treatmentType)) {
      this.storageService.treatmentType = <ConsultationTreatmentTypes>treatmentType;
    }

    return true;
  }
}
